/**
 * Loyers (rents) + Aides régionales (regional aids) — central constants.
 *
 * The user requested a realistic operating-cost model :
 *   - Loyers = monthly OPEX (depots + office), NOT capitalised on the
 *     balance sheet (pure rental, not an asset).
 *   - Aides régionales = annual benefits granted at January 1st when the
 *     player meets specific challenges. Bundle of 3 aids — all cumulable.
 *
 * 28/05/2026 v2 — Phase A + B in one shot.
 */

export const LEASE_RATES = {
  // €/month — fully agreed with the user (29/05/2026)
  hq: 1200,         // depot HQ (slot #1, always active)
  secondary: 800,   // additional built depots (slots 2-3) — Croissance Interne
  acquired: 1500,   // M&A inherited depots (slots 4-6) — Croissance Externe
  office: 1500,     // HQ office (siège social) — only if unlocked
};

export const REGIONAL_AIDS = [
  {
    id: 'aid-hq-rent',
    name: 'Aide à l\'emploi — Loyer dépôt HQ offert',
    sender: 'Conseil Régional',
    senderRole: 'support',
    durationMonths: 12,
    benefit: { type: 'rent_waiver_hq' },
    condition: { type: 'net_hires_min', value: 5 },
    description: '5 emplois CDI nets créés sur l\'année écoulée (chauffeurs + fonctions support) — la Région prend en charge le loyer du dépôt principal pendant 12 mois.',
  },
  {
    id: 'aid-office-rent',
    name: 'Aide à l\'innovation — Subvention FEDER Bureau',
    sender: 'Conseil Régional',
    senderRole: 'support',
    durationMonths: 12,
    benefit: { type: 'rent_waiver_office', oneShot: 5000 },
    condition: { type: 'support_min', value: 3 },
    description: '3 fonctions support recrutées — la Région offre 12 mois de loyer bureau ET une subvention FEDER « Bureau » de 5 000 € versée immédiatement, pour vous aider à financer votre siège social.',
  },
  {
    id: 'aid-cfe-exoneration',
    name: 'Exonération CFE — Investissement local',
    sender: 'Conseil Régional',
    senderRole: 'support',
    durationMonths: 12,
    benefit: { type: 'cfe_reduction', percent: 15 },
    condition: { type: 'capex_year_min', value: 50000 },
    description: 'Investissement ≥ 50 000 € en CAPEX sur l\'année écoulée — exonération partielle de Cotisation Foncière des Entreprises (-15 % sur les charges fiscales annexes pendant 12 mois).',
  },
];

export const AID_BY_ID = Object.fromEntries(REGIONAL_AIDS.map(a => [a.id, a]));
